const reducers = {
  setOss: (state, action) => {
    state.oos = action.payload
  },
  setOosWithInfo: (state, action) => {
    state.oosWithInfo = action.payload
  },
  setLoading: (state, action) => {
    state.loading = action.payload
  },
  setAddress: (state, action) => {
    state.address = {
      ...state.address,
      ...action.payload
    }
  },
  setImageSlider: (state, action) => {
    state.imageSlider = action.payload
  },
  setInfo: (state, action) => {
    state.info = action.payload
  },
  setQuantity: (state, action) => {
    state.quantity = action.payload
  },
  setSeeMore: (state, action) => {
    state.seeMore = action.payload
  },
  setSelection: (state, action) => {
    state.selection = action.payload
  },
  setEngraving: (state, action) => {
    state.engraving = {
      ...state.engraving,
      ...action.payload
    }
  },
  setBundle: (state, action) => {
    state.bundle = action.payload
  }
}

export default reducers
